const setFunctionIntoHook = functionToSet => {
  return () => functionToSet
}

export {
  setFunctionIntoHook
}
